import React from 'react';

const RepairCompany = React.lazy(() => import('pages/RepairCompany/pages/RepairCompany'));
const RepairCompanyAdd = React.lazy(() => import('pages/RepairCompany/pages/RepairCompanyAdd'));
const RepairCompanyEdit = React.lazy(() => import('pages/RepairCompany/pages/RepairCompanyEdit'));
const RepairCompanyDetail = React.lazy(() => import('pages/RepairCompany/pages/RepairCompanyDetail'));

const RepairCompanyRoutes = [
  {
    path: '/repair-company',
    exact: true,
    name: 'Danh sách nhà sửa chữa',
    function: 'SL_REPAIRCOMPANY_VIEW',
    component: RepairCompany,
  },
  {
    path: '/repair-company/add',
    exact: true,
    name: 'Thêm mới nhà sửa chữa',
    function: 'SL_REPAIRCOMPANY_ADD',
    component: RepairCompanyAdd,
  },
  {
    path: '/repair-company/edit/:id',
    exact: true,
    name: 'Chỉnh sửa nhà sửa chữa',
    function: 'SL_REPAIRCOMPANY_EDIT',
    component: RepairCompanyEdit,
  },
  {
    path: '/repair-company/detail/:id',
    exact: true,
    name: 'Chi tiết nhà sửa chữa',
    function: 'SL_REPAIRCOMPANY_DETAIL',
    component: RepairCompanyDetail,
  },
];

export default RepairCompanyRoutes;
